export default "__VITE_ASSET__DI4W1kFR__"